// extracted by mini-css-extract-plugin
var _1 = "TextMeUpdates_container__FFotn";
var _2 = "TextMeUpdates_disclaimer__E6o7p";
export { _1 as "container", _2 as "disclaimer" }
